import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Template } from '../../Components/Template/template'
import { FeedbackMessage } from '../../Components/FeedbackMessage/feedback-message'
import { Link, useParams } from 'react-router-dom'
import {
    AlertType, Conta, InputsRefs, barraVermelhoAzul, bgBlue, bgRed, classBorderLabelDark, classBt, classDivBackground, classDivBody, classDtCriarAtt,
    classInput, classInputDark, classLabel, classLabelDark, classUserCriarAtt, classWeigthBt, classbtAzul, classbtCinzaClaro, classbtColunasVermelho,
    focusLabelRed, focusRed
} from '../../Utils/Types'
import { IoSave } from 'react-icons/io5'
import { FcNook } from 'react-icons/fc'
import { BsBoxArrowInLeft } from 'react-icons/bs'
import { Funcoes } from '../../Utils/Funcoes'
import { FormaPagamentoService } from './FormaPagamentoService'
import moment from 'moment'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faClipboardList, faFolder } from '@fortawesome/free-solid-svg-icons'
import { Icone } from '../../Components/Icones/Index'
import { DataSearch, SearchBox } from '../../Components/SearchBox/SearchBox'
import { AiOutlineClear } from 'react-icons/ai'
import { FaRegQuestionCircle, FaVideo } from 'react-icons/fa'
import { Tooltip } from 'react-tooltip'
import { ModalTutorial } from '../../Components/Modal/modal-tutorial'

type CampoObrigatorio = {
    campo: string,
    erro: boolean,
}

export const FormaPagtoNew = () => {

    // ----------------- TABS --------------------------------------------------------
    type Tab = {
        index: number,
        titulo: String,
        active: boolean,
        icon: IconProp,
    }

    const itabs: Tab[] = [
        { index: 0, titulo: 'Dados Principais', active: true, icon: faFolder },
        { index: 1, titulo: 'Auditoria', active: false, icon: faClipboardList },
    ]

    const [tabs, setTabs] = useState<Tab[]>(itabs)


    // ------------- CAMPOS OBRIGATORIOS ----------------------------------------------
    const fieldsMandatory: CampoObrigatorio[] = [
        { campo: 'descricao', erro: false },    // Posição 0 do Array.
        { campo: 'tipo', erro: false },         // Posição 1 do Array.  
        { campo: 'ordem', erro: false },        // Posição 2 do Array.  
    ]

    const [CamposObrigatorios, setCamposObrigatorios] = useState<CampoObrigatorio[]>(fieldsMandatory)

    // ------------------ ATRIBUTOS ---------------------------------------------------
    const { idFormaPagto } = useParams<string>()
    const [id, setId] = useState(0)
    const [descricao, setDescricao] = useState("")
    const [descricaoCopia, setDescricaoCopia] = useState("")
    const [tipo, setTipo] = useState("")
    const [pacrescimo, setPacrescimo] = useState("")
    const [pdesconto, setPdesconto] = useState("")
    const [ordem, setOrdem] = useState("")
    const [vl_minimo, setVl_minimo] = useState("")
    const [crediario, setCrediario] = useState("N")
    const [contas, setContas] = useState<DataSearch[]>([])
    const [contasOriginal, setContasOriginal] = useState<Conta[]>([])
    const [idConta, setIdConta] = useState(0)

    // ---------- ATRIBUTOS FEEDBACK -------------------------------------------------
    const [visible, setVisible] = useState(false)
    const [loading, setLoading] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("SUCCESS")

    // ---------- ATRIBUTOS AUDITORIA -------------------------------------------------
    const [userCriador, setUserCriador] = useState("")
    const [dtCriador, setDtCriador] = useState("")
    const [usertAtt, setUsertAtt] = useState("")
    const [dtAtt, setDtAtt] = useState("")

    // ---------- SEARCHBOX -----------------------------------------------------------
    const [visibleSearchBoxContas, setVisibleSearchBoxContas] = useState<boolean>(false)

    // ---------- ATRIBUTOS TUTORIAL ----------------------------------
    const [modalTutorialVisible, setModalTutorialVisible] = useState(false)


    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- ATRIBUTOS E EFFECT --------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const getAttributes = async () => {

        setLoading(true)

        try {

            const formaPagamentoAttributes = await FormaPagamentoService.GetAttributes(idFormaPagto || '0')

            let newContasList: DataSearch[] = []
            setContasOriginal(formaPagamentoAttributes.data.contas)

            formaPagamentoAttributes.data.contas.map((item: any) => {
                newContasList.push(
                    {
                        id: item.id,
                        description: item.descricao,
                    }
                )
            })

            setContas(newContasList)

            if (formaPagamentoAttributes.data && idFormaPagto) {

                setId(formaPagamentoAttributes.data.formaPagamento.id)
                setDescricao(formaPagamentoAttributes.data.formaPagamento.descricao)
                setDescricaoCopia(formaPagamentoAttributes.data.formaPagamento.descricao)
                setPacrescimo(formaPagamentoAttributes.data.formaPagamento.pacrescimo?.toString() || '')
                setPdesconto(formaPagamentoAttributes.data.formaPagamento.pdesconto?.toString() || '')
                setOrdem(formaPagamentoAttributes.data.formaPagamento.ordem?.toString() || '')
                setVl_minimo(formaPagamentoAttributes.data.formaPagamento.vl_minimo?.toString() || '')
                setTipo(formaPagamentoAttributes.data.formaPagamento.tipo)
                setUserCriador(formaPagamentoAttributes.data.formaPagamento.name_user_insert || '')
                setUsertAtt(formaPagamentoAttributes.data.formaPagamento.name_user_last_update || '')
                setCrediario(formaPagamentoAttributes.data.formaPagamento.crediario || 'N')
                setIdConta(formaPagamentoAttributes.data.formaPagamento.id_conta)

                if (formaPagamentoAttributes.data.formaPagamento.dt_cadastro) {
                    const dataFormatadaCriacao = moment(formaPagamentoAttributes.data.formaPagamento.dt_cadastro).format('DD/MM/YYYY HH:mm')
                    setDtCriador(dataFormatadaCriacao)
                }

                if (formaPagamentoAttributes.data.formaPagamento.dt_last_update) {
                    const dataFormatadaAtt = moment(formaPagamentoAttributes.data.formaPagamento.dt_last_update).format('DD/MM/YYYY HH:mm')
                    setDtAtt(dataFormatadaAtt)
                }

            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível carregar os dados`)

        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getAttributes()
        inputFocus()
    }, [])

    const handleMouseUp = useCallback((e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        // Desfocar o link após o clique
        const target = e.target as HTMLElement
        if (target instanceof HTMLAnchorElement) {
            target.blur()
        }

        inputFocus()
    }, [])

    const handleChangeTab = async (tab: number) => {
        let newTabs = await tabs.map((item) => {
            if (item.index === tab) {
                itabs[item.index].active = true
            } else {
                itabs[item.index].active = false
            }
            return itabs[item.index]
        })
        setTabs(newTabs)
        searchBoxFocus()
    }

    useEffect(() => {

        if (tabs[0].active) {
            inputFocus()
        }

    }, [tabs])

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- INPUTS --------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const descricaoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDescricao(e.target.value)
    }

    const tipoChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setTipo(e.target.value)
    }

    const pacrescimoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPacrescimo(Funcoes.MaskMoney(e.target.value))
    }

    const pdescontoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPdesconto(Funcoes.MaskMoney(e.target.value))
    }

    const ordemChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setOrdem(e.target.value.replace(/[^0-9]/g, ''))
    }

    const vl_minimoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setVl_minimo(Funcoes.MaskMoney(e.target.value))
    }

    const handleCrediarioChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setCrediario(e.target.value)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- CONTAS --------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleClearConta = useCallback(() => {
        setDefaultContas()
        setIdConta(0)

        setVisibleSearchBoxContas(false)
        boxFocusContas()
    }, [contasOriginal])

    const handleFilterContaClick = useCallback((description: string) => {
        if (description === "") {
            setDefaultContas()
        } else {
            let newContasList: DataSearch[] = []
            let newContasOriginalList = contasOriginal.filter(item => item.descricao.toLocaleLowerCase().startsWith(description.toLocaleLowerCase()))
            newContasOriginalList.map(item =>
                newContasList.push(
                    {
                        id: item.id,
                        description: item.descricao,
                    }
                )
            )
            setContas(newContasList)
        }
    }, [contasOriginal])

    const handleSetIdContaClick = useCallback((conta: any) => {

        if (conta) {
            setDefaultContas()
            setIdConta(conta.id)
        }
        setVisibleSearchBoxContas(false)
        boxFocusContas()
    }, [contasOriginal])

    const setDefaultContas = () => {
        let newContasList: DataSearch[] = []
        contasOriginal.map(item =>
            newContasList.push(
                {
                    id: item.id,
                    description: item.descricao,
                }
            )
        )
        setContas(newContasList)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- FORMA DE PAGAMENTO --------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const NovoFormaPagto = () => {

        setId(0)
        setDescricao('')
        setTipo('')
        setPacrescimo('')
        setPdesconto('')
        setOrdem('')
        setVl_minimo('')
        setCrediario('N')
        setIdConta(0)

        setDtCriador('')
        setUserCriador('')
        setDtAtt('')
        setUsertAtt('')

        if (messageType === 'DANGER') {
            setVisible(false)
        }

        searchBoxFocus()
        redefinirCampos()
        inputFocus()
    }

    const handleSaveFormaPagto = async () => {

        if (messageType === 'DANGER') {
            setVisible(false)
        }
        setLoading(true)
        searchBoxFocus()

        try {

            let formaPagamento = {
                id: id,
                descricao: descricao,
                pacrescimo: pacrescimo,
                pdesconto: pdesconto,
                ordem: ordem,
                vl_minimo: vl_minimo,
                tipo: tipo,
                crediario: crediario,
                idConta: idConta,
            }

            const resp = await FormaPagamentoService.Save(formaPagamento)

            if (resp.error) {

                setVisible(true)
                setMessageType("DANGER")
                setMessage(resp.msg || ``)
                //checkDadosObrigatorios()
            }
            else {

                setVisible(true)
                setId(resp.id || 0)
                setMessageType("SUCCESS")
                setMessage(id > 0 ? `Dados da forma de pagamento atualizados com sucesso` : resp.msg || ``)

                if (resp.dt_cadastro) {
                    const dataFormatadaCriacao = moment(resp.dt_cadastro).format('DD/MM/YYYY HH:mm')
                    setDtCriador(dataFormatadaCriacao)
                }

                if (resp.dt_last_update) {
                    const dataFormatadaAtt = moment(resp.dt_last_update).format('DD/MM/YYYY HH:mm')
                    setDtAtt(dataFormatadaAtt)
                }

                setDescricaoCopia(resp.data.formaPagto.descricao)
                setUserCriador(resp.name_user_insert || '')
                setUsertAtt(resp.name_user_last_update || '')

                redefinirCampos()

            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(id > 0 ? `Não foi possível atualizar os dados da forma de pagamento. Por favor, tente novamente` : `Não foi possível salvar os dados da forma de pagamento. Por favor, tente novamente`)

        } finally {
            const timer = setTimeout(() => {
                setLoading(false)
                inputFocus()
                clearTimeout(timer)
            }, 1200)
        }
    }

    const checkDadosObrigatorios = (): boolean => {

        if (descricao.trim() === '') {
            let fieldsM: CampoObrigatorio[] = CamposObrigatorios.map((item) => {
                return { campo: item.campo, erro: item.campo === 'descricao' ? true : false }
            }
            )
            setCamposObrigatorios(fieldsM)
            return true
        }

        if (tipo.trim() === '') {
            let fieldsM: CampoObrigatorio[] = CamposObrigatorios.map((item) => {
                return { campo: item.campo, erro: item.campo === 'tipo' ? true : false }
            }
            )
            setCamposObrigatorios(fieldsM)
            return true
        }

        if (parseInt(ordem) <= 0 || ordem.trim() === '') {
            let fieldsM: CampoObrigatorio[] = CamposObrigatorios.map((item) => {
                return { campo: item.campo, erro: item.campo === 'ordem' ? true : false }
            }
            )
            setCamposObrigatorios(fieldsM)
            return true
        }

        return false
    }

    const redefinirCampos = async () => {

        let fieldsM: CampoObrigatorio[] = [
            { campo: 'descricao', erro: false }, // Posição 0 do Array.
            { campo: 'tipo', erro: false },   // Posição 1 do Array. 
            { campo: 'ordem', erro: false },   // Posição 2 do Array.        
        ]

        setCamposObrigatorios(fieldsM)

    }

    const inputFocus = () => {
        const inputElement = document.getElementById("descricao")
        inputElement?.focus()
    }

    const handleCloseMessage = () => {
        setVisible(false)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- FOCUS ABA 1 ---------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const inputsRefs: InputsRefs = {
        descricao: useRef(null),
        tipoPagamento: useRef(null),
        acrescimo: useRef(null),
        desconto: useRef(null),
        ordem: useRef(null),
        valorMin: useRef(null),
        formaCred: useRef(null),
        contas: useRef(null),
    }

    const handleTabPress = (event: any, inputKey: any) => {

        if (event.key === 'Tab' && tabs[0].active) {

            event.preventDefault() // Evita o comportamento padrão do 'Tab'

            searchBoxFocus()

            // Obtenha as chaves dos elementos em ordem
            const keys = Object.keys(inputsRefs)

            // Encontre o índice do campo atual
            let currentIndex = keys.indexOf(inputKey)
            let nextIndex = currentIndex

            // Loop para encontrar o próximo campo habilitado e focável
            do {
                nextIndex = (nextIndex + 1) % keys.length;

                const nextEl = inputsRefs[keys[nextIndex]].current;

                if (!nextEl) continue;
                if (nextEl.disabled) continue;
                if (nextEl.tabIndex === -1) continue;
                if (nextEl.offsetParent === null) continue; // está invisível (ex: display: none)

                break;
            } while (nextIndex !== currentIndex);

            if (nextIndex === 7) {
                setVisibleSearchBoxContas(true)
                inputFocusContas()
            }

            // Direcione o foco para o próximo campo habilitado e focável, se encontrado
            const nextRef = inputsRefs[keys[nextIndex]].current;
            if (nextRef && typeof nextRef.focus === 'function') {
                nextRef.focus();
            }
        }
    }

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {

            if (event.key === 'Tab' && tabs[0].active) {

                event.preventDefault()

                const inputSearchContas = document.getElementById('inputSearchBox-contas') as HTMLInputElement

                if (document.activeElement === inputSearchContas) {
                    inputsRefs['descricao'].current?.focus()
                    setVisibleSearchBoxContas(false)
                }
            }
        }

        document.addEventListener('keydown', handleKeyDown)

        return () => {
            document.removeEventListener('keydown', handleKeyDown)
        }
    }, [tabs])

    const searchBoxFocus = () => {
        setVisibleSearchBoxContas(false)
    }

    // Contas -----------------------------------------------------------------
    const boxFocusContas = () => {
        // Move o foco para o input correspondente à chave 'contas'.
        inputsRefs['contas'].current?.focus()
    }

    const clickSearchBoxContas = useCallback(() => {
        setVisibleSearchBoxContas((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                inputFocusContas() // Executa ao abrir
            }
            return newState
        })
        boxFocusContas() // Sempre executa
    }, [])

    const inputFocusContas = () => {
        let inputSearch = document.getElementById(`inputSearchBox-contas`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- FOCUS ABA 2 ---------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleTabPressNone = (event: any) => {

        if (event.key === 'Tab' && tabs[1].active) {
            event.preventDefault() // Evita o comportamento padrão do 'Tab'
        }
    }

    useEffect(() => {

        document.addEventListener('keydown', handleTabPressNone)

        return () => {

            document.removeEventListener('keydown', handleTabPressNone)
        }

    }, [tabs])

    const btNovoVisible = parseInt(idFormaPagto || '') > 0 ? 'invisible hidden' : 'visible'

    return (
        <Template isLoading={loading}>

            <div className={`${classDivBackground}`}>

                <div id='div-body' className={`${classDivBody}`}>

                    <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                    <div className={`bg-white dark:bg-slate-600 border border-slate-300 dark:border-slate-800 shadow-md shadow-indigo-200 dark:shadow-slate-800 rounded-lg`}>

                        <div className={`h-[50px] w-full flex items-center my-3 px-2`}>
                            <FcNook className={`text-slate-700 dark:text-slate-200 ml-2 mr-2`} size="25px" color='#333' />
                            <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200 break-all mx-2`}>{parseInt(idFormaPagto || '') || id > 0 ? `Editar - Forma de Pagamento - ${descricaoCopia} ` : 'Cadastro - Forma de Pagamento'}</span>

                            <button onClick={() => { setModalTutorialVisible(true) }} tabIndex={-1} disabled={loading} className={`${classBt} ${classbtAzul} ${classWeigthBt} shadow-md shadow-blue-600`}  >
                                <FaVideo />
                                <span className='mx-1'>Tutorial</span>
                            </button>
                        </div>

                        <div className={`w-full h-full`}>

                            <div className={`h-[60px] flex overflow-x-auto scrollable_horizontal border border-slate-200 dark:border-slate-700`}>
                                {tabs.map((item) => {
                                    return (

                                        <button tabIndex={-1} onClick={() => handleChangeTab(item.index)} key={item.index.toString()}
                                            className={`px-4 font-mono font-bold w-[180px]
                                                ${item.active ?
                                                    `hover:text-sky-500 text-sky-600 border border-b-[3px] border-l-0 border-t-0 border-r-slate-300 border-b-sky-600 dark:text-slate-200 dark:border-r-slate-700 dark:border-b-slate-300` :
                                                    `text-sky-600 dark:text-slate-300 bg-slate-100 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600 border border-l-0 border-t-0 border-b-0 dark:border-slate-800`
                                                } `}>
                                            <div tabIndex={-1} className={`flex items-center`}>
                                                <span className={`mr-2`}><Icone icon={item.icon} /></span>
                                                <span className={`text-sm roboto whitespace-nowrap`}>{item.titulo}</span>
                                            </div>
                                        </button>
                                    )
                                })}
                            </div>

                            <div className={`${tabs[0].active ? 'block' : 'hidden'} relative `}>

                                <div className={`flex flex-col sm:flex-row`}>

                                    <div className={`w-full h-full grid gap-5 grid-cols-12 p-4`}>

                                        <div className={`relative col-span-12 space-y-1`}>
                                            <div className={`flex flex-row`}>
                                                <span className={`text-[14px] text-[#ACACAC] dark:text-slate-300 mr-2`}>Dados da Forma de Pagamento</span>
                                                <FaRegQuestionCircle tabIndex={-1} data-tooltip-id={'tooltip-btn-question'} id={'btn-question'} className={`text-[#ACACAC] dark:text-slate-300 cursor-pointer`} size={18} />
                                                <Tooltip id={'tooltip-btn-question'} anchorSelect={'#btn-question'} positionStrategy="fixed" place='top' >
                                                    <span >Os campos com borda <br /> vermelha são obrigatórios</span>
                                                </Tooltip>
                                            </div>
                                            <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-700`} />
                                        </div>

                                        <div className={`relative col-span-12 sm:col-span-6`}>
                                            <div className={`${barraVermelhoAzul} ${descricao != '' ? bgBlue : bgRed}`} />
                                            <input ref={inputsRefs.descricao} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'descricao')} id="descricao" className={`${classInput} ${classInputDark}  ${descricao != '' ? '' : focusRed}`} type='text' inputMode='text' maxLength={155} autoComplete='off' placeholder=" " value={descricao} onFocus={searchBoxFocus} onChange={descricaoChange} />
                                            <label htmlFor="descricao" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${descricao != '' ? '' : focusLabelRed}`}>Descrição</label>
                                        </div>

                                        <div className={`relative col-span-12 sm:col-span-6 xl:col-span-4`}>

                                            <div className={`${barraVermelhoAzul} ${tipo != '' ? bgBlue : bgRed}`} />
                                            <select ref={inputsRefs.tipoPagamento} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'tipoPagamento')} id="tipo" className={`${classInput} ${classInputDark} ${tipo != '' ? '' : focusRed}  ${tipo === "" ? `text-blue-500 dark:text-cyan-300` : ``}`} value={tipo} onFocus={searchBoxFocus} onChange={tipoChange}  >
                                                <option value="" className={`text-blue-500 dark:text-cyan-300`}>(selecione)</option>
                                                <option value="01" className={`text-slate-900 dark:text-slate-200`}>Dinheiro</option>
                                                <option value="02" className={`text-slate-900 dark:text-slate-200`}>Cheque</option>
                                                <option value="03" className={`text-slate-900 dark:text-slate-200`}>Cartão de Crédito</option>
                                                <option value="04" className={`text-slate-900 dark:text-slate-200`}>Cartão de Débito</option>
                                                <option value="05" className={`text-slate-900 dark:text-slate-200`}>Crédito Loja</option>
                                                <option value="10" className={`text-slate-900 dark:text-slate-200`}>Vale Alimentação</option>
                                                <option value="11" className={`text-slate-900 dark:text-slate-200`}>Vale Refeição</option>
                                                <option value="12" className={`text-slate-900 dark:text-slate-200`}>Vale Presente</option>
                                                <option value="13" className={`text-slate-900 dark:text-slate-200`}>Vale Combustível</option>
                                                <option value="15" className={`text-slate-900 dark:text-slate-200`}>Boleto Bancário</option>
                                                <option value="16" className={`text-slate-900 dark:text-slate-200`}>Depósito Bancário</option>
                                                <option value="17" className={`text-slate-900 dark:text-slate-200`}>Pagamento Instantâneo (PIX)</option>
                                                <option value="18" className={`text-slate-900 dark:text-slate-200`}>Transferência bancária, Carteira Digital</option>
                                                <option value="19" className={`text-slate-900 dark:text-slate-200`}>Programa de fidelidade, Cashback, Crédito Virtual</option>
                                                <option value="90" className={`text-slate-900 dark:text-slate-200`}>Sem Pagamento</option>
                                                <option value="99" className={`text-slate-900 dark:text-slate-200`}>Outros</option>
                                            </select>
                                            <label htmlFor="tipo" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${tipo != '' ? '' : focusLabelRed}`}>Tipo de Pagamento</label>
                                        </div>

                                        <div className={`relative col-span-12 sm:col-span-3 xl:col-span-2`}>
                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                            <input ref={inputsRefs.acrescimo} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'acrescimo')} id="pacrescimo" className={`${classInput} ${classInputDark}`} type="text" inputMode='numeric' placeholder=" " autoComplete='off' value={pacrescimo} onFocus={searchBoxFocus} onChange={pacrescimoChange} />
                                            <label htmlFor="pacrescimo" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Acrescimo</label>
                                        </div>

                                        <div className={`relative col-span-12 sm:col-span-3 xl:col-span-2`}>
                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                            <input ref={inputsRefs.desconto} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'desconto')} id="pdesconto" className={`${classInput} ${classInputDark}`} type="text" inputMode='numeric' placeholder=" " autoComplete='off' value={pdesconto} onFocus={searchBoxFocus} onChange={pdescontoChange} />
                                            <label htmlFor="pdesconto" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Desconto</label>
                                        </div>

                                        <div className={`relative col-span-12 sm:col-span-3 xl:col-span-2`}>
                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                            <input ref={inputsRefs.ordem} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'ordem')} id="ordem" className={`${classInput} ${classInputDark}`} type="text" inputMode='numeric' placeholder=" " autoComplete='off' value={ordem} onFocus={searchBoxFocus} onChange={ordemChange} />
                                            <label htmlFor="ordem" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Ordem</label>
                                        </div>

                                        <div className={`relative col-span-12 sm:col-span-3 xl:col-span-2`}>
                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                            <input ref={inputsRefs.valorMin} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'valorMin')} id="vl_minimo" className={`${classInput} ${classInputDark}`} type="text" inputMode='numeric' placeholder=" " autoComplete='off' value={vl_minimo} onFocus={searchBoxFocus} onChange={vl_minimoChange} />
                                            <label htmlFor="vl_minimo" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Valor Min.</label>
                                        </div>

                                        <div className={`relative col-span-12 sm:col-span-3 xl:col-span-2`}>
                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                            <select ref={inputsRefs.formaCred} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'formaCred')} id="crediario" className={`${classInput} ${classInputDark}`} value={crediario} onFocus={searchBoxFocus} onChange={handleCrediarioChange}>
                                                <option value="S">Sim</option>
                                                <option value="N">Não</option>
                                            </select>
                                            <label htmlFor="crediario" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Forma crediário</label>
                                        </div>

                                        <div className={`relative col-span-12 sm:col-span-6 xl:col-span-4`}>

                                            <div ref={inputsRefs['contas']} tabIndex={0} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'contas')} />
                                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                            <SearchBox
                                                dataList={contas}
                                                idRegistro={idConta || undefined}
                                                label='Conta'
                                                componentId='contas'
                                                visibleTAB={visibleSearchBoxContas}
                                                setDataClick={handleSetIdContaClick}
                                                clearDataClick={handleClearConta}
                                                filterDataClick={handleFilterContaClick}
                                                clicado={clickSearchBoxContas}
                                            />
                                        </div>

                                    </div>

                                </div>

                                <div className={`flex flex-col space-y-3 m-4 sm:space-y-0 sm:space-x-4 sm:flex-row sm:justify-end`}>

                                    <Link tabIndex={-1} onMouseUp={handleMouseUp} to="/formaPagto" className={`${classbtColunasVermelho} ${classWeigthBt}`} >
                                        <BsBoxArrowInLeft size="20px" className='mr-[5px]' /> Voltar
                                    </Link>

                                    <button tabIndex={-1} onClick={NovoFormaPagto} className={`${classBt} ${btNovoVisible} ${classbtCinzaClaro} ${classWeigthBt}`}>
                                        <AiOutlineClear size="20px" className='mr-[5px]' /> Limpar Campos
                                    </button>

                                    <button tabIndex={-1} onClick={handleSaveFormaPagto} disabled={loading} className={`${classBt} ${classbtAzul} ${classWeigthBt}`}>
                                        {!loading && <IoSave size="16px" className={`mr-[5px]`} />}
                                        {loading &&
                                            <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                            </div>
                                        }
                                        {parseInt(idFormaPagto || '0') > 0 || id != 0 ? !loading ? 'Atualizar' : 'Aguarde' : !loading ? 'Salvar' : 'Aguarde'}

                                    </button>

                                </div>

                            </div>

                            <div className={`${tabs[1].active ? 'block' : 'hidden'} relative h-[400px] sm:h-[200px]`}>

                                <div className={`w-full h-full flex flex-row p-4`}>

                                    <div className={`w-full grid grid-cols-12`}>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="userCriacaoPag" className={`${classUserCriarAtt}`}>Criador</label>
                                            <span id="userCriacaoPag" className={`${classDtCriarAtt}`}>{userCriador}</span>
                                        </div>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="dtCriacaoPag" className={`${classUserCriarAtt}`}>Data de Criação</label>
                                            <span id="dtCriacaoPag" className={`${classDtCriarAtt}`} >{dtCriador}</span>
                                        </div>

                                    </div>

                                    <div className={`w-full grid grid-cols-12`}>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="userAttPag" className={`${classUserCriarAtt}`}>Atualizador</label>
                                            <span id="userAttPag" className={`${classDtCriarAtt}`} >{usertAtt}</span>
                                        </div>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="dtAttPag" className={`${classUserCriarAtt}`}>Data de Atualização</label>
                                            <span id="dtAttPag" className={`${classDtCriarAtt}`} >{dtAtt}</span>
                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                    {modalTutorialVisible &&
                        <ModalTutorial
                            linkVideo='/tutorial_formaPagamento.mp4'
                            title='Como cadastrar uma forma de pagamento'
                            visible={modalTutorialVisible}
                            onCloseClick={() => setModalTutorialVisible(false)}
                        />
                    }

                </div>

            </div>

        </Template>
    )
}